import React from 'react';

function ucFromRow(row) {
  const terms = [
    row.ref_std_unc,
    row.repeatability_std,
    row.resolution,   // aquí guardas u_res (paso/√12)
    row.drift_std,
    row.other_std,
  ].filter((x) => x !== null && typeof x === 'number' && !Number.isNaN(x));
  if (!terms.length) return null;
  const sum2 = terms.reduce((acc, x) => acc + x * x, 0);
  return Math.sqrt(sum2);
}
const fmt = (v, digits = 6) => (v === null || v === undefined ? '—' : Number(v).toFixed(digits));

export default function SavedMeasurementsTable({ rows = [], onDelete }) {
  return (
    <div className="overflow-x-auto border rounded">
      <table className="min-w-full text-sm">
        <thead className="bg-muted/50">
          <tr>
            <th className="text-left px-3 py-2">Setpoint</th>
            <th className="text-left px-3 py-2">Media</th>
            <th className="text-left px-3 py-2">Error</th>
            <th className="text-left px-3 py-2">u<sub>c</sub></th>
            <th className="text-left px-3 py-2">U (k·u<sub>c</sub>)</th>
            <th className="text-left px-3 py-2">k</th>
            <th className="text-left px-3 py-2">Acciones</th>
          </tr>
        </thead>
        <tbody>
          {(!rows || rows.length === 0) ? (
            <tr>
              <td className="px-3 py-3 text-muted-foreground" colSpan={7}>
                No hay mediciones guardadas.
              </td>
            </tr>
          ) : (
            rows.map((r) => {
              const e = r.reading != null && r.setpoint != null ? r.reading - r.setpoint : null;
              const ucRow = ucFromRow(r);
              const Urow = ucRow != null && r.coverage_k ? ucRow * r.coverage_k : null;
              return (
                <tr key={r.id} className="border-t">
                  <td className="px-3 py-2">{fmt(r.setpoint)}</td>
                  <td className="px-3 py-2">{fmt(r.reading)}</td>
                  <td className="px-3 py-2">{fmt(e)}</td>
                  <td className="px-3 py-2">{fmt(ucRow)}</td>
                  <td className="px-3 py-2">{fmt(Urow)}</td>
                  <td className="px-3 py-2">{r.coverage_k ?? '—'}</td>
                  <td className="px-3 py-2">
                    <button
                      className="text-red-600 hover:underline"
                      onClick={() => onDelete?.(r.id)}
                      title="Eliminar medición"
                    >
                      Eliminar
                    </button>
                  </td>
                </tr>
              );
            })
          )}
        </tbody>
      </table>
    </div>
  );
}
